import React from 'react';
import PropTypes from 'prop-types';

const Bell = props => {
  const { color, width, height, ...other } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" {...other}>
      <g>
        <path d="M19.5,3.4c-0.1-0.4,0.1-0.8-0.2-1.2c-0.2-0.3-0.6-0.5-0.6-0.5S18.3,1.4,18,1.5c-0.5,0-0.7,0.4-1.1,0.5
                    c-0.7,0.3-3.4-1.1-5.7,0.7c-2.6,1.9-3.8,6.8-7.7,7.7c-3.7,0.8-0.6,7.5,4.9,10.5s12.8,1.8,11.4-1.7c-1.4-3.7,2-7.5,2.2-10.7
                    C22.2,5.6,19.6,4.1,19.5,3.4z M18,20.4c-0.2,0.3-1.2,0.5-2.4,0.5c-0.2,0-0.3,0-0.5,0c-1.4-0.1-3.5-0.4-5.8-1.6
                    c-3.9-2.1-6-6.1-5.7-6.6c0.9-1.8,6.1,0.3,8.5,1.5C14.3,15.4,19,18.7,18,20.4z" fill={color} />
        <path d="M10.6,14.6c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0.1c0,0-0.8,2.2,1.9,3.8c1,0.6,1.9,0.8,2.6,0.8c1.1,0,1.7-0.6,1.8-0.6
                    c0,0,0.1-0.1,0-0.1c0,0,0-0.1-0.1-0.1C14.4,16.8,13.2,16,10.6,14.6z" fill={color} />
      </g>
    </svg>
  );
}

Bell.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

Bell.defaultProps = {
  color: '#000000',
  width: 24,
  height: 24,
};

export default Bell;



// WEBPACK FOOTER //
// ./src/components/Icons/Bell.jsx